<template>
  <span class="meeting-status" :class="`meeting-status--${status}`">
    <i v-if="spinning" class="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
    {{ label }}
  </span>
</template>

<script>
import { isProcessing, statusLabel } from './meetingHelpers'

/**
 * Statut d'une réunion CSE : pilule au format des types de contenus, le
 * libellé français porte l'information, la couleur l'appuie.
 */
export default {
  name: 'app-meeting-status-pill',
  props: {
    status: { type: String, default: '' }
  },
  computed: {
    label () {
      return statusLabel(this.status)
    },
    spinning () {
      return isProcessing(this.status) && this.status !== 'queued'
    }
  }
}
</script>

<style scoped>
.meeting-status {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 5px 10px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #4b5563;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.25rem;
  white-space: nowrap;
}

.meeting-status--transcribing,
.meeting-status--synthesizing {
  background: #dbeafe;
  color: #1d4ed8;
}

/* En attente d'un élu : ambre, comme les points d'attention. */
.meeting-status--reviewing {
  background: #fef3c7;
  color: #92400e;
}

.meeting-status--completed {
  background: #dcfce7;
  color: #166534;
}

.meeting-status--failed {
  background: #fee2e2;
  color: #b91c1c;
}
</style>
